function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M3.29 17.364c-.989 0-1.79.814-1.79 1.818S2.301 21 3.29 21c.987 0 1.788-.814 1.788-1.818s-.8-1.818-1.789-1.818M3.29 3C2.301 3 1.5 3.814 1.5 4.818s.801 1.818 1.79 1.818c.987 0 1.788-.814 1.788-1.818S4.278 3 3.29 3m0 7.312c-.988 0-1.789.814-1.789 1.818s.801 1.818 1.79 1.818c.987 0 1.788-.814 1.788-1.818s-.8-1.818-1.789-1.818m19.75 7.611H8.821c-.709 0-1.283.574-1.283 1.282 0 .708.574 1.282 1.283 1.282h14.216c.709 0 1.283-.574 1.283-1.282 0-.708-.574-1.282-1.283-1.282m0-7.205H8.822c-.709 0-1.283.574-1.283 1.282 0 .708.574 1.282 1.283 1.282h14.216c.709 0 1.283-.574 1.283-1.282 0-.708-.574-1.282-1.283-1.282M7.54 4.795c0-.708.574-1.282 1.283-1.282h14.216c.709 0 1.283.574 1.283 1.282 0 .708-.574 1.282-1.283 1.282H8.822c-.709 0-1.283-.574-1.283-1.282"
});

function SvgTimeline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37,
    height: 39,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeline);
export default __webpack_public_path__ + "static/media/timeline.009e5a37.svg";
export { ForwardRef as ReactComponent };